import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/homeData';
import { heroBgUrl } from '@/mocks/imageUrls';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroBgUrl}
          alt="豪门国际"
          className="w-full h-full object-cover object-top"
          title="豪门国际 - 通往顶级国际资源的首选平台"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60" />
      </div>

      <div className="relative z-10 container-custom text-center">
        <div className="max-w-4xl mx-auto">
          <p className="font-label text-sm md:text-base tracking-[0.3em] text-primary-300 mb-6 animate-fade-in-up">
            HAOMEN INTERNATIONAL
          </p>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 mb-6 leading-tight animate-fade-in-up">
            {heroData.title}
          </h1>
          <p className="font-heading text-xl md:text-2xl lg:text-3xl text-primary-300 font-medium mb-8 animate-fade-in-up">
            {heroData.subtitle}
          </p>
          <p className="text-sm md:text-base text-background-50/70 max-w-2xl mx-auto leading-relaxed mb-10 animate-fade-in-up">
            {heroData.description}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up">
            <Link
              to="/about"
              className="px-8 py-3.5 text-sm font-medium whitespace-nowrap rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 cursor-pointer shadow-[0_0_30px_rgba(200,160,60,0.3)]"
            >
              {heroData.cta}
            </Link>
            <Link
              to="/category/resources"
              className="px-8 py-3.5 text-sm font-medium whitespace-nowrap rounded-full border border-background-50/30 text-background-50 hover:bg-background-50/10 transition-all duration-300 cursor-pointer"
            >
              {heroData.ctaSecondary}
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 animate-bounce">
        <div className="w-8 h-12 rounded-full border-2 border-background-50/30 flex items-start justify-center pt-2">
          <div className="w-1 h-2.5 bg-background-50/60 rounded-full" />
        </div>
      </div>
    </section>
  );
}